import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { AuthGate } from './components/AuthGate'
import { IS_DEMO } from './demo'
import './index.css'

// The public demo (?demo=1) renders without a session; everything else is signed-in Studio.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {IS_DEMO ? (
      <App />
    ) : (
      <AuthGate>
        <App />
      </AuthGate>
    )}
  </React.StrictMode>,
)
